<template>
  <header-app :titlepage="$t('Pay '+$route.params.name)" back="true"></header-app>
  <v-main class="main" >
    ssss
  </v-main>
  <footer-app selectedItem="1"></footer-app>
</template>

<script setup>
import HeaderApp from "@/views/headerApp.vue";
import FooterApp from "@/views/FooterApp.vue";
import DataView from "@/views/DataView.vue";
</script>

<script>
import router from "@/router";
import http from "@/plugins/axios";

export default {
  name: 'pay-view',

  data: () => ({
    category :  {
      data: [],
      lang : []
    },
  }),
}
</script>

<style scoped>

</style>